import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CargueModule } from './modules/cargue/cargue.module';
import { PresupuestoRoutingModule } from './presupuesto-routing.module';


@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    CargueModule,
    PresupuestoRoutingModule
  ]
})
export class PresupuestoModule { }